import { Theme } from '@material-ui/core/styles';

export const RELAY_CHIP_BACKGROUND = '#e8eef5';

export const getRelayChipTextColor = (theme: Theme): string => theme.palette.admin.primary.dark;
